// 

import { useEffect, useRef } from 'react';
import './customPagination.css';
import logger from '../../../utils/logger';

export const CustomPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
}) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage);
  const paginationRef = useRef(null); // 👈🏼 Referencia

  useEffect(() => {
    if (paginationRef.current) {
      const outerContainer = paginationRef.current.parentElement;

      // ✅ Ahora podés agregarle clase o estilos
      outerContainer.classList.add('parentElement-CustomPagination');


      logger.info('Contenedor externo del paginador:', outerContainer);
    }
  }, [])

  const handlePageClick = (page) => {
    if (page !== currentPage) onChangePage(page);
  };

  const handleRowsPerPageChange = (e) => {
    onChangeRowsPerPage(Number(e.target.value));
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else if (currentPage <= 4) {
      pageNumbers.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (currentPage > totalPages - 4) {
      pageNumbers.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
    return pageNumbers;
  };

  const startRecord = (currentPage - 1) * rowsPerPage + 1;
  const endRecord = Math.min(currentPage * rowsPerPage, rowCount);

  return (
    <div className="pagination-container" ref={paginationRef}>
      <label htmlFor='registros'>Mostrar registros:</label>
      <select id='registros' value={rowsPerPage} onChange={handleRowsPerPageChange}>
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
      </select>

      <span style={{ marginLeft: 10 }}>
        {startRecord} - {endRecord} de {rowCount} registros
      </span>

      <button onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 1}>
        &laquo;
      </button>

      {getPageNumbers().map((page, index) =>
        page === '...' ? (
          <span key={index} style={{ padding: '6px 12px' }}>...</span>
        ) : (
          <button
            key={index}
            onClick={() => handlePageClick(page)}
            className={page === currentPage ? 'active' : ''}
          >
            {page}
          </button>
        )
      )}

      <button onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages}>
        &raquo;
      </button>
    </div>
  );
};
